import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import AboutYourMentorBlock from '../components/AboutYourMentorBlock';
import LivingRoomConsole, { DELETE_FILES_CONFIRM_MESSAGE } from '../components/LivingRoomConsole';
import LivingRoomQrModal from '../components/LivingRoomQrModal';
import { promptAppInstall } from '../lib/pwaInstall';
import { SCREENS } from '../lib/screenRegistry';

const CORPORATE_WELCOME =
  "Welcome to the Organisation Briefing Room, [Mentee Name]. I am your AI Mentor Jill. This workspace is built around the Workplace Performance Engine — we will align your team frameworks, leadership track commitments, and organisational accountability loops. There is no passive listening. Share the primary workplace challenge or strategic insight you bring today, and the performance outcome you intend to advance.";

const SUBSCRIPTION_ID = 'ELT-ORG-DEV-9842';

export default function CorporateMenteeLounge() {
  const navigate = useNavigate();
  const [qrOpen, setQrOpen] = useState(false);

  const handleCreateAppIcon = async (closeMenu: () => void) => {
    closeMenu();
    await promptAppInstall();
  };

  const handleDeleteFiles = async (closeMenu: () => void) => {
    closeMenu();
    if (!window.confirm(DELETE_FILES_CONFIRM_MESSAGE)) return;
    const result = await authApi.deleteData();
    if (!result.success) alert(result.message || result.reason);
    else alert('File deletion initiated.');
  };

  return (
    <LivingRoomConsole
      screenId={SCREENS.ELT09}
      welcomeScript={CORPORATE_WELCOME}
      assetBlocks={<AboutYourMentorBlock />}
      menuContent={(closeMenu) => (
        <>
          <p className="living-room-util-item living-room-util-static">
            Subscription: {SUBSCRIPTION_ID}
          </p>
          <a
            className="living-room-util-item"
            href="mailto:support@mentology.com.au?subject=Contact%20My%20Mentor"
            onClick={closeMenu}
          >
            Contact My Mentor
          </a>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              navigate('/pro-setup');
            }}
          >
            Change my AI-Mentor Voice
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => {
              closeMenu();
              setQrOpen(true);
            }}
          >
            Click for QR code to launch a desktop/homepage AI APP icon
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => handleCreateAppIcon(closeMenu)}
          >
            Create AI-Mentor app icon desktop/homepage
          </button>
          <button
            type="button"
            className="living-room-util-item"
            onClick={() => handleDeleteFiles(closeMenu)}
          >
            Delete all my files
          </button>
        </>
      )}
      qrModal={qrOpen ? (
        <LivingRoomQrModal
          titleId="corporate-lounge-qr-title"
          onClose={() => setQrOpen(false)}
        />
      ) : null}
    />
  );
}
